import * as axios from 'axios';
import { API } from './config';
import questions from '../../public/api/data.json';
import exemptions from '../../public/api/exemptions.json';

let responses = [];

//Retrieve a list of questions from a locally hosted json file.
const getData = async function () {
    try {
        const response = await axios.get(`${API}/data.json`);
        let data = parseList(response);
        const questions = data;
        return questions;
    } catch (error) {
        console.error(error);
        return [];
    }
};

const getQuestions = function () {
    return questions;
}

const resetResponses = function () {
    responses = [];
}

//Ensure that the data we are returning can be accessed and also contains an object data type
const parseList = response => {
    if (response.status != 200) throw Error(response.message);
    if (!response.data) return [];
    let list = response.data;
    if (typeof list != 'object') {
        list = [];
    }
    return list;
};

//Parse the current URL to ensure we retriece the correct question from the data
const parseUrl = function () {
    var splitUrl = window.location.href.split("/");
    return splitUrl[splitUrl.length - 1].trim("#");
};

//retrieve an element from our array based on the id matching the supplied propValue
const findElement = function (arr, propValue) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]["id"] == propValue) {
            return arr[i];
        }
    }
    //return "";
};

const findIndex = function (arr, propValue) {
    for (var i = 0; i < arr.length; i++)
        if (arr[i]["id"] == propValue) return i;
}

//log a users response to a question when the move to the next question
const logResponse = function (response) {
    let previousResponse = findElement(responses, response.id);
    if (previousResponse != undefined) {
        if (previousResponse.responses) {
            if (isEqual(previousResponse.responses, response.responses)) {
                return responses.length;
            } else {
                let removeIndex = responses.indexOf(previousResponse);
                responses.splice(removeIndex, 1);
                responses.push(response);
            }
        } else {
            let removeIndex = responses.indexOf(previousResponse);
            responses.splice(removeIndex, 1);
            responses.push(response);
        }
    } else {
        responses.push(response);
    }
    return responses.length;
};

const wasAnsweredBefore = function (id) {
    return findElement(responses, id);
}

//retrieve the user's responses for the results page
const getResponses = function () {
    return responses;
};

//retrieve the payment exemptions that apply to our current user based on their responses
const getExemptionsForUser = function () {
    let exemptions = getExemptions();
    let exempt = [];
    let notExempt = [];
    exemptions.exemptions.forEach(function (exemption) {
        if (isExempt(exemption)) {
            exempt.push(exemption.exemptionType);
        } else {
            notExempt.push(exemption.exemptionType);
        }
    });

    let userExemptions = {
        exempt: exempt,
        notExempt: notExempt
    };
    return userExemptions;
};

//logic to determine whether or not the user is exempt from payment for the passed in exemption
const isExempt = function (exemption) {
    if (exemption.criteria.length == 0) {
        return true;
    } else {
        let criteriaResults = [];
        let exempt = true;
        exemption.criteria.forEach(function (criteria) {
            let response = findElement(responses, criteria.id);
            if (response.questionType == "Checkbox") {
                response.responses.forEach(function (r) {
                    criteriaResults.push(isExemptForCriteria(criteria, r));
                });
            } else {
                criteriaResults.push(isExemptForCriteria(criteria, response));
            }
        });
        exempt = criteriaResults.some(function (result) {
            return result;
        });
        return exempt;
    }
}

const isExemptForCriteria = function (criteria, response) {
    if (criteria.exceptionCriteria == "less than") {
        if (response.responseId < criteria.exceptionValue && (criteria.mustAlso.length == 0 && criteria.shouldAlso.length == 0)) {
            return false;
        } else if (response.responseId < criteria.exceptionValue && criteria.mustAlso.length > 0) {
            let must = criteria.mustAlso.every(function (also) {
                var alsoResponse = findElement(responses, also.id);
                if (alsoResponse) {
                    if (alsoResponse.questionType == "Checkbox") {
                        let checkboxAlso = false;
                        alsoResponse.responses.forEach(function (a) {
                            checkboxAlso = isExemptForMust(also, a);
                        });
                        return checkboxAlso;
                    } else {
                        return isExemptForMust(also, alsoResponse);
                    }
                } else {
                    return true;
                }
            });
            return must;
        } else if (response.responseId < criteria.exceptionValue && criteria.shouldAlso.length > 0) {
            let should = criteria.shouldAlso.some(function (some) {
                var someResponse = findElement(responses, some.id);
                if (someResponse) {
                    if (someResponse.questionType == "Checkbox") {
                        let checkboxSome = someResponse.responses.some(function (s) {
                            return isExemptForShould(some, s);
                        });
                        return checkboxSome;
                    } else {
                        return isExemptForShould(some, someResponse);
                    }
                } else {
                    return false;
                }
            });
            return should;
        }
    } else if (criteria.exceptionCriteria == "greater than") {
        if (response.responseId > criteria.exceptionValue && (criteria.mustAlso.length == 0 && criteria.shouldAlso.length == 0)) {
            return false;
        } else if (response.responseId > criteria.exceptionValue && criteria.mustAlso.length > 0) {
            let must = criteria.mustAlso.every(function (also) {
                var alsoResponse = findElement(responses, also.id);
                if (alsoResponse) {
                    if (alsoResponse.questionType == "Checkbox") {
                        let checkboxAlso = false;
                        alsoResponse.responses.forEach(function (a) {
                            checkboxAlso = isExemptForMust(also, a);
                        });
                        return checkboxAlso;
                    } else {
                        return isExemptForMust(also, alsoResponse);
                    }
                } else {
                    return true;
                }
            });
            return must;
        } else if (response.responseId > criteria.exceptionValue && criteria.shouldAlso.length > 0) {
            let should = criteria.shouldAlso.some(function (some) {
                var someResponse = findElement(responses, some.id);
                if (someResponse) {
                    if (someResponse.questionType == "Checkbox") {
                        let checkboxSome = someResponse.responses.some(function (s) {
                            return isExemptForShould(some, s);
                        });
                        return checkboxSome;
                    } else {
                        return isExemptForShould(some, someResponse);
                    }
                } else {
                    return false;
                }
            });
            return should;
        }
    }
}

const isExemptForMust = function (also, alsoResponse) {
    if (also.exceptionCriteria == "less than") {
        if (alsoResponse.responseId < also.exceptionValue) {
            return true;
        } else {
            return false;
        }
    } else if (also.exceptionCriteria == "greater than") {
        if (alsoResponse.responseId > also.exceptionValue) {
            return true;
        } else {
            return false;
        }
    } else {
        if (alsoResponse.responseId == also.exceptionValue) {
            return true;
        } else {
            return false;
        }
    }
}

const isExemptForShould = function (some, someResponse) {
    if (some.exceptionCriteria == "less than") {
        if (someResponse.responseId < some.exceptionValue) {
            return true;
        } else {
            return false;
        }
    } else if (some.exceptionCriteria == "greater than") {
        if (someResponse.responseId > some.exceptionValue) {
            return true;
        } else {
            return false;
        }
    } else {
        if (someResponse.responseId == some.exceptionValue) {
            return true;
        } else {
            return false;
        }
    }
}

//retrieve a list of the exemptions a user may be entitled to from a locally hosted execptions json file
// const getExemptions = async function () {
//     try {
//         const response = await axios.get(`${API}/exemptions.json`);
//         let data = parseList(response);
//         const exemptions = data;
//         return exemptions;
//     } catch (error) {
//         console.error(error);
//         return [];
//     }
// };

const getExemptions = function () {
    return exemptions;
}

const setTestData = function () {
    responses = [
        {
            "id": "Intro",
            "questionType": "Checkbox",
            "responseId": "Intro",
            "response": "You have declared that have & acknowledged the information"
        },
        {
            "id": "AreYouRegistered",
            "questionType": "Radio",
            "responseId": 0,
            "response": "Yes"
        },
        {
            "id": "DueToFracture",
            "questionType": "Radio",
            "responseId": 1,
            "response": "No"
        },
        {
            "id": "HaveYouHadSurgeryInPast3Months",
            "questionType": "Radio",
            "responseId": 1,
            "response": "No"
        },
        {
            "id": "HaveYouAttendedAE",
            "questionType": "Radio",
            "responseId": 1,
            "response": "No"
        },
        {
            "id": "DoYouRequireAHomeVisit",
            "questionType": "Radio",
            "responseId": 1,
            "response": "No"
        },
        {
            "id": "AreYouOver14",
            "questionType": "Radio",
            "responseId": 0,
            "response": "Yes"
        },
        {
            "id": "NameAndGender",
            "questionType": "NameAndGender",
            "firstName": "Colin",
            "surname": "Anderson",
            "gender": "Male",
            "responseId": 0
        },
        {
            "id": "DOB",
            "questionType": "DateOfBirth",
            "responseId": 43,
            "response": "You have declared that you are 43 years old",
            "day": "19",
            "month": "12",
            "year": "1977"
        },
        {
            "id": "Occupation",
            "questionType": "Occupation",
            "employmentStatus": "Employed",
            "occupation": "Web developer"
        },
        {
            "id": "AddressDetails",
            "questionType": "AddressDetails",
            "towncity": "Bellshill",
            "streetname": "Main Street",
            "streetnumber": "8",
            "postcode": "XX3 5XX"
        },
        {
            "id": "ContactDetails",
            "questionType": "AddressDetails",
            "confirmemail": "canderson@tactuum.com",
            "emailaddress": "canderson@tactuum.com",
            "telephonehome": "01234567890",
            "telephonemobile": "01234567890",
            "telephonework": "01234567890"
        },
        {
            "id": "GpDetails",
            "questionType": "GpDetails",
            "gpname": "My GP Name",
            "gpaddress": "My GP Address, Town"
        },
        {
            "id": "Interpreter",
            "questionType": "Interpreter",
            "interpreter": "Yes",
            "interpreterLanguage": "French",
            "interpreterGenderId": 0,
            "interpreterGender": "Male",
            "responseId": 0
        },
        {
            "id": "SpecialRequirements",
            "questionType": "SpecialRequirements",
            "specialRequirements": "Yes",
            "specialRequirementsText": "Test special requirements",
            "responseId": 0
        },
        {
            "id": "ProblemLocations",
            "questionType": "Checkbox",
            "responses": [
                {
                    "responseId": 2,
                    "response": "3. Right Shoulder"
                },
                {
                    "responseId": 3,
                    "response": "4. Right Upper Arm"
                },
                {
                    "responseId": 4,
                    "response": "5. Right Elbow"
                },
                {
                    "responseId": 5,
                    "response": "6. Right Lower Arm"
                }
            ]
        },
        {
            "id": "BriefDescription",
            "questionType": "BriefDescription",
            "briefDescription": "description of my problem"
        },
        {
            "id": "FirstTimeProblem",
            "questionType": "Radio",
            "responseId": 0,
            "response": "Yes"
        },
        {
            "id": "RecentFallOrInjury",
            "questionType": "Radio",
            "responseId": 1,
            "response": "No"
        },
        {
            "id": "Physiotherapy",
            "questionType": "Radio",
            "responseId": 1,
            "response": "No"
        },
        {
            "id": "Clinics",
            "questionType": "Checkbox",
            "responses": [
                {
                    "responseId": 2,
                    "response": "Orthopaedics"
                },
                {
                    "responseId": 3,
                    "response": "Other"
                }
            ],
            "otherClinic": "some other clinic"
        },
        {
            "id": "HowLong",
            "questionType": "HowLong",
            "howLong": "More than 12 weeks",
            "numberOfWeeks": "22",
            "responseId": 2
        },
        {
            "id": "WorseOrBetter",
            "questionType": "Radio",
            "responseId": 2,
            "response": "Not changing"
        },
        {
            "id": "DescribePain",
            "questionType": "Radio",
            "responseId": 1,
            "response": "Moderate"
        },
        {
            "id": "PainComingGoing",
            "questionType": "Radio",
            "responseId": 0,
            "response": "Yes"
        },
        {
            "id": "PainDisturbingSleep",
            "questionType": "Radio",
            "responseId": 2,
            "response": "No"
        },
        {
            "id": "Activities",
            "questionType": "Radio",
            "responseId": 0,
            "response": "Not at all"
        },
        {
            "id": "OffWork",
            "questionType": "offWork",
            "offWork": "Yes",
            "howLongOffWork": "too long",
            "responseId": 0
        },
        {
            "id": "Carer",
            "questionType": "Radio",
            "responseId": 1,
            "response": "No"
        },
        {
            "id": "MilitaryService",
            "questionType": "Radio",
            "responseId": 1,
            "response": "No"
        }
    ];
}

const canShowSummary = function () {
    var showSummary = findElement(responses, "ShowSummary");
    return showSummary && showSummary.showSummary === "Yes";
}

const getCompleteData = function () {
    console.log(responses);
    var showSummary = findElement(responses, "ShowSummary");
    var nameAndGender = findElement(responses, "NameAndGender");
    var dob = findElement(responses, "DOB");
    var occupation = findElement(responses, "Occupation");
    var addressDetails = findElement(responses, "AddressDetails");
    var contactDetails = findElement(responses, "ContactDetails");
    var gpDetails = findElement(responses, "GpDetails");
    var interpreter = findElement(responses, "Interpreter");
    var specialRequirements = findElement(responses, "SpecialRequirements");
    var problemLocations = findElement(responses, "ProblemLocations");
    var briefDescription = findElement(responses, "BriefDescription");
    var firstTimeProblem = findElement(responses, "FirstTimeProblem");
    var recentFallOrInjury = findElement(responses, "RecentFallOrInjury");
    var physiotherapy = findElement(responses, "Physiotherapy");
    var clinics = findElement(responses, "Clinics");
    var howLong = findElement(responses, "HowLong");
    var worseOrBetter = findElement(responses, "WorseOrBetter");
    var describePain = findElement(responses, "DescribePain");
    var painComingGoing = findElement(responses, "PainComingGoing");
    var painDisturbingSleep = findElement(responses, "PainDisturbingSleep");
    var activities = findElement(responses, "Activities");
    var offWork = findElement(responses, "OffWork");
    var carer = findElement(responses, "Carer");
    var militaryService = findElement(responses, "MilitaryService");
    
    var dataObject = {
        showSummary: showSummary.showSummary,
        name: (nameAndGender != null && nameAndGender.firstName != null ? nameAndGender.firstName : "") + " " + (nameAndGender != null && nameAndGender.surname != null ? nameAndGender.surname : ""),
        gender: nameAndGender.gender,
        dob: dob != null ? dob.day + "/" + dob.month + "/" + dob.year : "",
        occupation: occupation != null ? occupation.employmentStatus === "Employed" ? occupation.occupation : occupation.employmentStatus : "",
        streetNumber: addressDetails != null ? addressDetails.streetnumber : "",
        streetName: addressDetails != null ? addressDetails.streetname : "",
        town: addressDetails != null ? addressDetails.towncity : "",
        postcode: addressDetails != null ? addressDetails.postcode : "",
        telephoneHome: contactDetails != null ? contactDetails.telephonehome : "",
        telephoneMobile: contactDetails != null ? contactDetails.telephonemobile : "",
        telephoneWork: contactDetails != null ? contactDetails.telephonework : "",
        emailAddress: contactDetails != null ? contactDetails.emailaddress : "",
        gpName: gpDetails != null ? gpDetails.gpname : "",
        gpAddress: gpDetails != null ? gpDetails.gpaddress : "",
        interpreter: interpreter != null ? interpreter.interpreter : "",
        interpreterLanguage: interpreter != null ? interpreter.interpreterLanguage : "",
        interpreterGender: interpreter != null ? interpreter.interpreterGender : "",
        specialRequirements: specialRequirements != null ? specialRequirements.specialRequirements : "",
        specialRequirementsText: specialRequirements != null ? specialRequirements.specialRequirementsText : "",
        problemLocations: [],
        briefDescription: briefDescription != null ? briefDescription.briefDescription : "",
        firstTimeProblem: firstTimeProblem != null ? firstTimeProblem.response : "",
        recentFallOrInjury: recentFallOrInjury != null ? recentFallOrInjury.response : "",
        physiotherapy: physiotherapy != null ? physiotherapy.response : "",
        clinics: [],
        clinicsOther: null,
        howLong: howLong != null ? howLong.howLong : "",
        howLongWeeks: howLong != null ? howLong.numberOfWeeks : "",
        worseOrBetter: worseOrBetter != null ? worseOrBetter.response : "",
        describePain: describePain != null ? describePain.response : "",
        painComingGoing: painComingGoing != null ? painComingGoing.response : "",
        painDisturbingSleep: painDisturbingSleep != null ? painDisturbingSleep.response : "",
        activities: activities != null ? activities.response : "",
        offWork: offWork != null ? offWork.offWork : "",
        howLongOffWork: offWork != null ? offWork.howLongOffWork : "",
        carer: carer != null ? carer.response : "",
        militaryService: militaryService != null ? militaryService.response : ""
    }

    if (problemLocations != null) {
        problemLocations.responses.forEach(function (r) {
            dataObject.problemLocations.push(r);
        });
    }
    if (clinics != null) {
        clinics.responses.forEach(function (r) {
            dataObject.clinics.push(r);
            if (r.responseId === 3) {
                dataObject.clinicsOther = clinics.otherClinic;
            }
        });
    }

    return dataObject;
}

const isEqual = function (a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;
  
    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.
    // Please note that calling sort on an array will modify that array.
    // you might want to clone your array first.
  
    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

export const dataService = {
    getData, getQuestions, resetResponses, parseUrl, findElement, findIndex, logResponse, wasAnsweredBefore, getResponses, getExemptionsForUser, canShowSummary, getCompleteData, setTestData
};
